// PayrollDetailedSummary

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { PAYROLL_DETAIL_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";

const PayrollDetailedSummary = () => {

    const [payrollDetailedSummaryData, setPayrollDetailedSummaryData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const payrollDetailedSummaryColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "earnings",
            Header: "Earning",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ctc",
            Header: "CTC/Month",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "deductions",
            Header: "Deductions",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "net_pay",
            Header: "Net Pay",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "lop",
            Header: "LOP",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "reimbursements",
            Header: "Reimbursements",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "credits",
            Header: "Credits",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "debit",
            Header: "Debit",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "paid_salary",
            Header: "Paid Salary",
            align: 'right',
            Cell: ({ value }) => value ?? "-",
        },

    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Payroll Detailed Summary Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={payrollDetailedSummaryColumns}
                data={payrollDetailedSummaryData}
                setData={setPayrollDetailedSummaryData}
                setTotalCount={setTotalRecords}
                url={PAYROLL_DETAIL_REPORTS}
                serverSide={true} 
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </div >
    );
}

export default PayrollDetailedSummary;